import app from 'apprun';
import { __ } from '../Txlat';
import { getAgencyLink, getUrl } from '../utility';

export default function ({ agency, hightlight }) {
  return (
    <div class="item-listing-wrap hz-item-gallery-js card" data-images="" style={hightlight ? 'border:3px solid red; width:100%; padding: 3px 5px; margin-bottom: 10px;' : 'padding: 3px 5px;margin-bottom: 10px;'}>
      <div class="item-wrap item-wrap-v1 item-wrap-no-frame h-100">
        <div class="d-flex align-items-center h-100" style={hightlight ? 'flex-direction:row' : ''}>
          <div class="item-body flex-grow-1">
            <ul class="item-amenities item-amenities-with-icons">
              <li>
                <h2 class="item-title mw-100" style="white-space: normal;overflow: visible;">
                  <a target={'agency' + agency.id} href={getAgencyLink(agency)}><b>{agency.name}</b></a>
                </h2>
              </li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <li>{agency.address}</li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <li>{agency.city.toUpperCase()}&nbsp;{agency.province.toUpperCase()}&nbsp;{agency.postal_code.toUpperCase()}</li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              {(agency.phone && agency.phone !== '') ? <li><strong>{__('Tel')}:</strong>&nbsp;<a href={'tel:' + agency.phone}><span class="agent-phone ">{agency.phone}</span></a></li> : ''}
            </ul>
            <ul class="item-amenities item-amenities-with-icons">
              {(agency.website && agency.website !== '') ? <li style='display: block;'><strong>{__('Website')}:</strong>&nbsp;<a href={getUrl(agency.website)} target='_blank' style={'overflow-wrap: break-word;'} >{agency.website}</a></li> : ''}
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <div class="d-flex flex-row">
                <div class="flex-grow-1">
                  <a class="btn btn-search btn-secondary " href={'mailto:' + agency.email} style='line-height:30px;color:white;' >{__('Contact this office')}</a>
                </div>
                <div class="mobile-switch">
                  <a $onclick={['/openMarker', agency.name]}><img height="30" src='/wp-content/themes/houzez/img/map/pin-agency.png' style="height:30px; cursor: pointer;" /></a></div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>

  );
}
